import { Controller } from "@hotwired/stimulus";

/**
 * 車両削除確認モーダル関連の機能
 */
export default class extends Controller {
  static targets = ["close"];

  /**
   * 車両削除時にモーダルを閉じないようにする
   */
  disableClose() {
    for (const target of this.closeTargets) {
      target.disabled = true;
    }
  }
}
